import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@material-ui/core/Typography'

const CircularProgressWithLabel = (props) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        maxWidth: '25px',
        maxHeight: '25px',
        marginTop: '0.2em',
      }}
    >
      <CircularProgress
        variant="determinate"
        {...props}
        sx={{ maxWidth: '25px', maxHeight: '25px' }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '25px',
          maxHeight: '25px',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          style={{ fontSize: '0.6rem' }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

export default CircularProgressWithLabel
